import { AddIcon, Box, Grid, IconButton, MinusIcon, styled, TextField } from 'opensolar-ui'
import { FC } from 'react'

const CONTROL_HEIGHT = 30

const QuantityButtonContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: CONTROL_HEIGHT,
  borderRadius: '6px',
  overflow: 'hidden',
}))

const QuantityBox = styled(Grid)(() => ({
  borderTop: `1px solid #CDCDCD`,
  borderBottom: `1px solid #CDCDCD`,
  height: CONTROL_HEIGHT,
}))

const StyledIconButton = styled(IconButton)(() => ({
  background: '#4272DD',
  color: 'white',
  padding: 0,
  height: CONTROL_HEIGHT,
  width: CONTROL_HEIGHT,
  borderRadius: 0,
  '&:hover': {
    background: '#113B98',
  },
}))

const StyledTextField = styled(TextField)(() => ({
  width: '100%',
  textAlign: 'center',
  border: 'none',
  background: 'transparent',
  padding: '0',

  '& .OSUI-OutlinedInput-notchedOutlinenotchedOutline': {
    border: 'none',
  },
  '&:hover .OSUI-OutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .Mui-focused .OSUI-OutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .OSUI-InputBase-root': {
    background: 'transparent',
  },
  '& fieldset': {
    border: 'none',
  },
  '& .MuiInputBase-root': {
    fontSize: '13px',
  },
  '& .MuiInputBase-input, & .OSUI-InputBase-input': {
    padding: '4px 6px',
  },
}))

interface MultiSelectQuantityControlProps {
  value: number
  onChange: (newQuantity: number) => void
  disabled?: boolean
}

const MIN_QUANTITY = 1

const MultiSelectQuantityControl: FC<MultiSelectQuantityControlProps> = ({ value, onChange, disabled = false }) => {
  const handleMinus = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (value <= MIN_QUANTITY) {
      onChange(0)
    } else {
      onChange(value - 1)
    }
  }

  const handlePlus = (e: React.MouseEvent) => {
    e.stopPropagation()
    onChange(value + 1)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation()
    const raw = e.target.value
    if (raw === '') {
      onChange(MIN_QUANTITY)
      return
    }
    const parsed = parseInt(raw, 10)
    if (!isNaN(parsed) && parsed >= MIN_QUANTITY) {
      onChange(parsed)
    }
  }

  const handleBlur = () => {
    if (value < MIN_QUANTITY) {
      onChange(MIN_QUANTITY)
    }
  }

  return (
    <QuantityButtonContainer>
      <StyledIconButton onClick={handleMinus} disabled={disabled}>
        <MinusIcon />
      </StyledIconButton>
      <QuantityBox container item justify="center" alignContent="center" xs={11}>
        <StyledTextField
          onClick={(e) => e.stopPropagation()}
          value={value}
          onChange={handleInputChange}
          onBlur={handleBlur}
          variant="outlined"
          inputProps={{
            min: MIN_QUANTITY,
            style: { textAlign: 'center', width: 36 },
          }}
          disabled={disabled}
        />
      </QuantityBox>
      <StyledIconButton onClick={handlePlus} disabled={disabled}>
        <AddIcon />
      </StyledIconButton>
    </QuantityButtonContainer>
  )
}

export default MultiSelectQuantityControl
